export const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'

export const doDisplayMessage = (message: string | null, isError = false) => ({
  type: DISPLAY_MESSAGE,
  payload: { message, isError },
})
export const doHideMessage = () => ({ type: HIDE_MESSAGE, payload: {} })
